import { render, staticRenderFns } from "./DisaggregatedStatistical.vue?vue&type=template&id=3cd27344&scoped=true"
import script from "./DisaggregatedStatistical.vue?vue&type=script&lang=js"
export * from "./DisaggregatedStatistical.vue?vue&type=script&lang=js"
import style0 from "./DisaggregatedStatistical.vue?vue&type=style&index=0&id=3cd27344&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd27344",
  null
  
)

export default component.exports